import { Component, Output, EventEmitter, OnInit } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './buttons.component.html',
  styleUrls: ['./buttons.component.scss']
})
export class ButtonsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  @Output() refreshClicked = new EventEmitter<void>();

  onClick() {
    this.refreshClicked.emit();
  }
}
